var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoxCogWrench = function SvgBoxCogWrench(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 175,
    viewBox: "0 0 227 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_50891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.286 69.3597C121.307 69.3597 119.272 65.839 121.747 61.5207C123.177 59.0177 122.325 55.8271 119.822 54.3968L115.063 51.6738C112.89 50.3811 110.085 51.1512 108.792 53.3241L108.49 53.8467C106.014 58.1651 101.943 58.1651 99.4404 53.8467L99.1378 53.3241C97.9001 51.1512 95.0945 50.3811 92.9216 51.6738L88.1632 54.3968C85.6602 55.8271 84.8076 59.0452 86.2378 61.5482C88.7408 65.839 86.7054 69.3597 81.727 69.3597C78.8664 69.3597 76.501 71.6977 76.501 74.5857L76.501 79.4266C76.501 82.2872 78.8389 84.6526 81.727 84.6526C86.7054 84.6526 88.7408 88.1733 86.2378 92.4917C84.8076 94.9946 85.6602 98.1852 88.1632 99.6155L92.9216 102.339C95.0945 103.631 97.9001 102.861 99.1928 100.688L99.4954 100.166C101.971 95.8473 106.042 95.8473 108.545 100.166L108.847 100.688C110.14 102.861 112.945 103.631 115.118 102.339L119.877 99.6155C122.38 98.1852 123.232 94.9671 121.802 92.4917C119.299 88.1733 121.335 84.6526 126.313 84.6526C129.174 84.6526 131.539 82.3147 131.539 79.4266L131.539 74.5857C131.512 71.7252 129.174 69.3597 126.286 69.3597ZM104.006 85.9454C99.0828 85.9454 95.067 81.9296 95.067 77.0062C95.067 72.0827 99.0828 68.067 104.006 68.067C108.93 68.067 112.945 72.0827 112.945 77.0062C112.945 81.9296 108.93 85.9454 104.006 85.9454Z",
    fill: "url(#paint0_linear_264_50891)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M81.7279 54.7003C81.5856 54.3325 81.2319 54.0901 80.8376 54.0901L40.297 54.0901C39.6263 54.0901 39.1648 54.7636 39.4067 55.3891L47.6402 76.6725L90.2278 76.6725L81.7279 54.7003Z",
    fill: "url(#paint1_linear_264_50891)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7404 44.4121C61.2723 43.3217 59.8527 43.0693 59.2405 44.0859C57.569 46.8618 57.2125 50.3748 58.5883 53.5796C60.4226 57.8527 64.7754 60.2705 69.169 59.8436L84.7738 100.118C85.6786 102.454 88.3404 103.572 90.6419 102.584C92.9528 101.592 93.9724 98.8752 92.8846 96.6078L74.3088 57.8873C78.1512 55.0876 79.6936 49.9121 77.7388 45.3586C76.2542 41.9002 73.1199 39.6571 69.6495 39.1538C68.5171 38.9895 67.7936 40.1685 68.245 41.22L71.011 47.6633C71.2561 48.2342 71.2643 48.879 71.0339 49.456L70.3649 51.1315C69.8852 52.3329 68.5223 52.918 67.3208 52.4383L65.6453 51.7692C65.0684 51.5388 64.6066 51.0887 64.3615 50.5178L61.7404 44.4121ZM89.4432 96.1713C90.0596 97.6071 89.9773 99.0209 89.2594 99.3291C88.5415 99.6373 87.4598 98.7231 86.8434 97.2873C86.227 95.8515 86.3094 94.4377 87.0273 94.1295C87.7452 93.8213 88.8268 94.7354 89.4432 96.1713Z",
    fill: "url(#paint2_linear_264_50891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.578 82.7707C112.707 80.1505 114.124 77.3197 116.744 76.448L146.408 66.5786C149.028 65.7069 151.859 67.1242 152.731 69.7445L166.564 111.324C167.436 113.944 166.019 116.775 163.399 117.647L133.735 127.516C131.115 128.388 128.284 126.97 127.412 124.35L113.578 82.7707Z",
    fill: "url(#paint3_linear_264_50891)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.371,
    y: 84.5546,
    width: 26.9102,
    height: 2.24251,
    rx: 1.12126,
    transform: "rotate(-18.4028 119.371 84.5546)",
    fill: "#64B5F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.071,
    y: 89.6616,
    width: 17.4916,
    height: 2.24251,
    rx: 1.12126,
    transform: "rotate(-18.4028 121.071 89.6616)",
    fill: "#64B5F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.77,
    y: 94.7683,
    width: 31.3952,
    height: 2.24251,
    rx: 1.12126,
    transform: "rotate(-18.4028 122.77 94.7683)",
    fill: "#64B5F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.469,
    y: 99.875,
    width: 17.4916,
    height: 2.24251,
    rx: 1.12126,
    transform: "rotate(-18.4028 124.469 99.875)",
    fill: "#64B5F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.442,
    y: 108.812,
    width: 10.3156,
    height: 2.24251,
    rx: 1.12126,
    transform: "rotate(-18.4028 127.442 108.812)",
    fill: "#64B5F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.858,
    y: 113.067,
    width: 13.4551,
    height: 2.24251,
    rx: 1.12126,
    transform: "rotate(-18.4028 128.858 113.067)",
    fill: "#64B5F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.967,
    cy: 103.296,
    r: 4.48503,
    transform: "rotate(-18.4028 153.967 103.296)",
    fill: "#64B5F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 106.76C152.003 106.512 152.207 106.314 152.454 106.317L154.765 106.346C155.013 106.349 155.211 106.552 155.208 106.8L155.15 111.522C155.145 111.949 154.602 112.127 154.344 111.787L153.904 111.206C153.727 110.973 153.378 110.969 153.196 111.198L152.741 111.767C152.475 112.101 151.937 111.909 151.942 111.482L152 106.76Z",
    fill: "#64B5F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.703 107.26C154.534 107.079 154.543 106.795 154.723 106.626L156.409 105.045C156.59 104.875 156.873 104.884 157.043 105.065L160.274 108.509C160.566 108.82 160.299 109.325 159.877 109.259L159.157 109.146C158.868 109.1 158.614 109.339 158.641 109.63L158.708 110.356C158.747 110.781 158.226 111.015 157.934 110.704L154.703 107.26Z",
    fill: "#64B5F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7236 76.8434L182.315 76.8434L182.315 141.753C182.315 147.025 178.042 151.298 172.77 151.298L57.2692 151.298C51.9973 151.298 47.7236 147.025 47.7236 141.753L47.7236 76.8434Z",
    fill: "url(#paint4_linear_264_50891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.565 76.8434L182.316 76.8434L182.316 141.753C182.316 147.025 178.042 151.298 172.77 151.298L145.565 151.298L145.565 76.8434Z",
    fill: "url(#paint5_linear_264_50891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.495 56.4715C152.632 56.0943 152.991 55.8432 153.392 55.8432L188.588 55.8432C189.25 55.8432 189.712 56.5014 189.485 57.124L182.314 76.8433L145.087 76.8433L152.495 56.4715Z",
    fill: "url(#paint6_linear_264_50891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7241 76.8434L145.088 76.8434L140.084 96.8605C139.659 98.5602 138.132 99.7526 136.38 99.7526L46.8871 99.7526C44.4031 99.7526 42.5804 97.4182 43.1829 95.0084L47.7241 76.8434Z",
    fill: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.815,
    y: 84.4798,
    width: 26.7275,
    height: 7.63642,
    rx: 1.9091,
    fill: "#99D0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_50891",
    x1: 104.377,
    y1: 51.0442,
    x2: 99.2655,
    y2: 106.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_50891",
    x1: 64.2327,
    y1: 54.0901,
    x2: 56.1642,
    y2: 117.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_50891",
    x1: 67.2025,
    y1: 47.4755,
    x2: 97.7944,
    y2: 104.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_264_50891",
    x1: 131.83,
    y1: 71.4287,
    x2: 142.867,
    y2: 127.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_264_50891",
    x1: 114.542,
    y1: 86.8662,
    x2: 115.719,
    y2: 151.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_264_50891",
    x1: 164.179,
    y1: 76.8434,
    x2: 148.906,
    y2: 153.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_264_50891",
    x1: 167.81,
    y1: 55.8432,
    x2: 175.776,
    y2: 114.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4DDFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_50891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172.066,
    height: 127,
    fill: "white",
    transform: "translate(29.074 25)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoxCogWrench);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "box-cog-wrench.4fd4feb5f3f9f8ca377ac02f6dd2b010.svg";